<ul>
    <li *ngFor="let item of block">
        <a class="color-inherit" *ngIf="!item.external" [routerLink]="navigationService.splitUrlRouterLink(item.link).path" [queryParams]="navigationService.splitUrlRouterLink(item.link).queryParams" href="JavaScript:void(0);">{{item.label}}</a>
        <a class="color-inherit" *ngIf="item.external" [href]="item.link" target="_blank" href="JavaScript:void(0);">{{item.label}}</a>
        <app-recursive-list *ngIf="item.subtree && item.subtree.length" [block]="item.subtree"></app-recursive-list>
    </li>
</ul>
